// extracted by mini-css-extract-plugin
export default {"page":"Dashboard_page__zBm2P","section":"Dashboard_section__YbGZY","container":"Dashboard_container__7bimc","title":"Dashboard_title__WTvE0"};